import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
/* import getIsBrightColor from '../../utils/getIsBrightColor' */
import OptionsContext from '../../utils/OptionsContext'
import useAnimation from '../../utils/hooks/useAnimation'
import Sound from '../Icons/Sound'
import styles from './VoiceoverButton.module.scss'
import { motion } from 'framer-motion'

const VoiceoverButton = ({
  as: Component = 'button',
  path = '08-talk',
  size = 'medium',
  variant = 'primary',
  // backgroundColor = '#FFFFFF',
  color = '#000000',
  ...otherProps
}) => {
  const { options, playVoiceover } = useContext(OptionsContext)
  const [audio, setAudio] = useState(null)
  const { t } = useTranslation('common')
  const [animateVoBtn, triggerVoBtn] = useAnimation({ scale: 1.4 })

  async function handlePlayVoiceover(event) {
    event.stopPropagation()
    if (audio) {
      audio.pause()
      setAudio(null)
      return
    }
    const playingAudio = await playVoiceover(path)
    setAudio(playingAudio)
  }

  useEffect(() => {
    if (audio) {
      audio.addEventListener('ended', () => setAudio(null))
      return () => audio.removeEventListener('ended', () => setAudio(null))
    }
  }, [audio])

  return (
    options.voiceover && (
      <span onMouseEnter={triggerVoBtn}>
        <Component
          onClick={handlePlayVoiceover}
          className={`${styles.button} ${styles[variant]} ${styles[size]}`}
          aria-label={t('playvoiceover')}
          /* style={{ color: getIsBrightColor(backgroundColor) ? '#000000' : '#FFFFFF' }} */
          style={{ color }}
          {...otherProps}
        >
          <motion.span animate={animateVoBtn} data-button="voiceover">
            <Sound />
          </motion.span>
        </Component>
      </span>
    )
  )
}

export default VoiceoverButton
